<template>
  <div class="Notification-fallback">
    <div class="Notification-fallbackGraphic">
      <svg>
        <use xlink:href="#bell" />
      </svg>
    </div>
    <h3>You are not currently logged in</h3>
    <p>Log in to see your saved jobs, reviews and companies.</p>
    <a
      class="Button Button--primary Button Button--long"
      @click.prevent="loginModal"
    ><span>Log in</span></a>
    or
    <p>
      <a
        class="text-link"
        @click.prevent="registerModal"
      ><span>Sign up</span></a>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    loginModal() {
      this.$bus.$emit('bus:authentication-modal:open-login-modal', { importComment: 'Notification Panel' });
      this.$bus.$emit('bus:notifications:close');
    },

    registerModal() {
      this.$bus.$emit('bus:authentication-modal:open-register-modal', { importComment: 'Side Panel Modal' });
      this.$bus.$emit('bus:notifications:close');
    },
  },
};
</script>
